module.exports = __webpack_public_path__ + "ad47178d9467c2f6f3de0264c9ad109f.jpg";